import { useState } from "react";

export function useDragAndDrop(initialSections) {
  const [sections, setSections] = useState(initialSections);
  const [draggedId, setDraggedId] = useState(null);
  const [dragOverId, setDragOverId] = useState(null);

  const handleDragStart = (id) => setDraggedId(id);

  const handleDragOver = (e, id) => {
    e.preventDefault();
    if (id !== draggedId) setDragOverId(id);
  };

  const handleDrop = (id) => {
    if (draggedId === id) return;
    const items = [...sections];
    const srcIndex = items.findIndex((item) => item.id === draggedId);
    const destIndex = items.findIndex((item) => item.id === id);

    const [removed] = items.splice(srcIndex, 1);
    items.splice(destIndex, 0, removed);

    setSections(items);
    setDraggedId(null);
    setDragOverId(null);
  };

  const handleDragEnd = () => {
    setDraggedId(null);
    setDragOverId(null);
  };

  return {
    sections,
    draggedId,
    dragOverId,
    handleDragStart,
    handleDragOver,
    handleDrop,
    handleDragEnd,
  };
}
